export const credentialCopy = {
  superAdminCreated: "Super admin created",
  temporaryCredentialReady: "Temporary credential ready",
  username: "Username",
  temporaryPassword: "Temporary password",
  copy: "Copy",
  copied: "Copied",
  setupNote: "Save the temporary password now. It is shown once and must be changed on first sign-in.",
  adminShareNote: "Share this temporary password securely. The user must change it on first sign-in."
} as const;

export const loginCopy = {
  mobileHeading: "Who's asking?",
  mobileBody: "Sign in so Jim can load your clause workspace.",
  eyebrow: "Workspace access",
  heading: "Sign in before you ask Jim.",
  body: "Clause answers stay tied to your role, saved checks, and audit trail.",
  usernameLabel: "Username",
  passwordLabel: "Password",
  submit: "Sign in",
  fieldAccessLabel: "Field access",
  fieldAccessHeading: "Jim will help you find the clause you're looking for based on site terms.",
  clauseBadge: "AS3000",
  jimSaysLabel: "Jim says",
  defaultPrompt: "Righto. Sign in and we can start.",
  defaultSupportLead: "You can ask me about things like",
  defaultSupportExamples: [
    "\"How close can a power point be to a kitchen sink?\"",
    "\"What protection do consumer mains need?\""
  ],
  defaultSupportClose: "and I'll try to hunt down the relevant clauses for you.",
  warningSupport: "Check the details and try again.",
  successPrompt: "That worked. Jim's opening the workspace.",
  successSupport: "Give him a second to line up the clause bench.",
  genericFailure: "Sign in failed"
} as const;

export const passwordCopy = {
  firstLoginHeading: "Change temporary password",
  heading: "Change password",
  currentPassword: "Current password",
  newPassword: "New password",
  recoveryEmail: "Recovery email",
  confirmRecoveryEmail: "Confirm recovery email",
  recoveryEmailMismatch: "Recovery email addresses do not match. Please check both entries.",
  submit: "Update password",
  failure: "Password update failed"
} as const;
